import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import { Box, Card, CardActionArea, Grid, Radio, Stack, Typography } from '@mui/material';
import { PortfolioRaw } from '../../../../types/b2tRatibiPlus';

type PortfolioCardsProps = {
  portfolios: PortfolioRaw[];
  selectedPortfolioId?: number;
  onSelect: (portfolioId: number) => void;
};

/** A company group's one product, picked from cards — Create Company Group and the treasury setup step. */
export const PortfolioCards = ({ portfolios, selectedPortfolioId, onSelect }: PortfolioCardsProps) => (
  <Grid container spacing={2}>
    {portfolios.map((p) => {
      const selected = selectedPortfolioId === p.id;
      const isDisabled = Boolean(p?.productType?.disabled);
      const select = () => {
        if (isDisabled || selected) return;
        onSelect(p.id);
      };
      let cardBorderColor: string;
      let cardBg: string;
      let cardColor: string;
      let radioCheckedColor: string;
      let radioBaseColor: string;
      if (isDisabled) {
        cardBorderColor = 'divider';
        cardBg = 'action.disabledBackground';
        cardColor = 'text.disabled';
        radioCheckedColor = 'text.disabled';
        radioBaseColor = 'text.disabled';
      } else {
        cardBorderColor = selected ? 'primary.main' : 'divider';
        cardBg = selected ? 'primary.main' : 'background.paper';
        cardColor = selected ? 'primary.contrastText' : 'text.primary';
        radioCheckedColor = selected ? 'primary.contrastText' : 'primary.main';
        radioBaseColor = selected ? cardColor : 'text.disabled';
      }
      return (
        <Grid item xs={12} sm={6} md={4} lg={3} key={p.id}>
          <Card
            variant="outlined"
            sx={{
              borderRadius: 3,
              borderColor: cardBorderColor,
              bgcolor: cardBg,
              color: cardColor,
              transition: 'all 0.15s ease-in-out',
              opacity: isDisabled ? 0.6 : 1,
              cursor: isDisabled ? 'not-allowed' : 'pointer',
            }}
          >
            <CardActionArea onClick={select} disabled={isDisabled} sx={{ p: 2 }}>
              <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={2}>
                <Box>
                  {p?.productType?.nameEn ? (
                    <Typography
                      variant="h6"
                      sx={{
                        fontWeight: 600,
                        fontSize: '20px',
                        lineHeight: 1.1,
                        opacity: isDisabled ? 0.8 : 0.9,
                      }}
                    >
                      {p.productType.nameEn}
                    </Typography>
                  ) : null}
                  <Typography variant="subtitle2" sx={{ fontWeight: 400, lineHeight: 1.2 }}>
                    {p.nameEn}
                  </Typography>
                </Box>
                <Radio
                  checked={selected}
                  onChange={select}
                  disabled={isDisabled}
                  icon={<RadioButtonUncheckedIcon />}
                  checkedIcon={<CheckCircleIcon />}
                  sx={{
                    color: radioBaseColor,
                    '&.Mui-checked': { color: radioCheckedColor },
                  }}
                />
              </Stack>
            </CardActionArea>
          </Card>
        </Grid>
      );
    })}
  </Grid>
);
